import { FC } from 'react';

import { TablePagination } from 'modules/_shared/Table/components/TablePagination';
import TableSkeleton from 'modules/_shared/components/Tables/TableSkeleton';

import NotesSectionTable from './CustomMovementsSectionTable';
import { useCustomMovementsSection } from '../context/CustomMovementsSectionContext';

const CustomMovementsSectionBody: FC = () => {
  const { data, actions } = useCustomMovementsSection();

  const showPagination =
    data.customMovements &&
    data.customMovementsTotal > (data.rowsPerPage || 10);

  return (
    <div className="mt-4">
      {data.isLoadingCustomMovements ? (
        <TableSkeleton
          rows={10}
          columns={4}
          showSubHeader={false}
          cardInner={false}
        />
      ) : (
        <NotesSectionTable />
      )}

      {showPagination && (
        <TablePagination
          totalRows={data.customMovementsTotal || 0}
          onChangePage={actions.handleChangePage}
          onChangeRowsPerPage={actions.handleChangeRowsPerPage}
        />
      )}
    </div>
  );
};
export default CustomMovementsSectionBody;
